import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ImageNotSupported from '../img/image-not-supported.svg';

const SmartImage = ({ src, alt, className, imageFail, title }) => {
  const [img, setImg] = useState(src);

  useEffect(() => {
    setImg(src);
  }, [src]);

  return (
    <img
      src={img}
      alt={alt}
      onError={() => setImg(imageFail)}
      className={className}
      title={title}
    />
  );
};

SmartImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  imageFail: PropTypes.string,
  title: PropTypes.string,
};

SmartImage.defaultProps = {
  title: '',
  className: '',
  imageFail: ImageNotSupported,
};

export default SmartImage;
